import React from 'react';
import { classNames } from 'react-extras';
import { v4 as UUIDv4 } from 'uuid';
import { SliceContext } from 'components/Slices/types';
import { withAppContext, AppContextType } from 'context/AppContext';
import { SegmentService } from 'analytics';

type WistiaVideoProps = {
    videoId: string;
    className?: string;
    autoplay?: boolean;
    slice?: SliceContext;
    context: AppContextType;
};

class WistiaVideoComponent extends React.Component<WistiaVideoProps> {
    handle: any;
    alreadyPlayed = false;
    // A unique ID needs to be passed to the Wistia player in order to be able to unbind
    // the event listener from the video.
    // Otherwise, when the video player is open and closed, there will be the same `id` applied to the player
    // and therefore there will be 2 added event listeners for the event.
    uuid: string = UUIDv4(); // eslint-disable-line new-cap

    componentDidMount() {
        if (!document.getElementById('wistia_script')) {
            const wistiaScript = document.createElement('script');
            wistiaScript.id = 'wistia_script';
            wistiaScript.type = 'text/javascript';
            wistiaScript.src = 'https://fast.wistia.com/assets/external/E-v1.js';
            wistiaScript.async = true;
            document.body.appendChild(wistiaScript);
        }

        window._wq = window._wq || [];
        window._wq.push({
            id: this.uuid,
            onReady: this.initializeVideo.bind(this),
        });
    }

    initializeVideo(video: any) {
        this.handle = video;
        if (this.props.autoplay) {
            video.play();
        }
        this.handle.bind('play', () => {
            if (this.alreadyPlayed === false) {
                SegmentService.trackVideoPlayed({ 'L - Video Name': this.props.videoId }, this.props.slice);
                this.alreadyPlayed = true;
            }
        });
    }

    componentWillUnmount() {
        if (!this.handle) {
            return;
        }
        this.handle.unbind();
        this.handle.remove();
        this.handle = null;
    }

    render() {
        return (
            <div
                id={this.uuid}
                className={classNames(
                    `wistia_embed wistia_async_${this.props.videoId} videoFoam=true WistiaVideo`,
                    this.props.className as string,
                )}
            >
                &nbsp;
            </div>
        );
    }
}

const WistiaVideo = withAppContext(WistiaVideoComponent);

export { WistiaVideo, WistiaVideoComponent, WistiaVideoProps };
